import axios from 'axios';

const API_KEY = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;
const CACHE_KEY = 'translationCache';

// Load cache from localStorage when the script runs
const loadCache = () => {
  const cacheData = localStorage.getItem(CACHE_KEY);
  return cacheData ? new Map(JSON.parse(cacheData)) : new Map();
};

// Save cache to localStorage
const saveCache = () => {
  localStorage.setItem(CACHE_KEY, JSON.stringify([...translationCache]));
};

// Initialize the translation cache
const translationCache = loadCache();

export const translateText = async (text, targetLang) => {
  if (targetLang === 'en') {
    return { translatedText: text, fromCache: false }; // Skip translation for English
  }

  const url = `https://translation.googleapis.com/language/translate/v2`;
  const cacheKey = `${text}_${targetLang}`;

  // Check if translation exists in cache
  if (translationCache.has(cacheKey)) {
    // console.log('Translation fetched from cache');
    return { translatedText: translationCache.get(cacheKey), fromCache: true };
  }

  try {
    const response = await axios.post(url, null, {
      params: {
        q: text,
        target: targetLang,
        key: API_KEY,
      },
    });

    let translatedText = response.data.data.translations[0].translatedText;

    // Store in cache and save to localStorage
    translationCache.set(cacheKey, translatedText);
    saveCache();

    // console.log('Translation fetched from API');
    return { translatedText, fromCache: false };
  } catch (error) {
    console.error('Translation error:', error);
    return { translatedText: text, fromCache: false }; // Return original text in case of error
  }
};
